import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ListItem, ThematicsIconProvider } from '@components';
import { Container, Icon, Typography } from '@design-system';
import { useCauseriesListPageVM } from './useCauseriesListPageVM';
import { CauseriesListPageSkeleton } from './CauseriesListPageSkeleton';

export const CauseriesListPage: React.FC = () => {
    const { isLoading, thematics } = useCauseriesListPageVM();
    const navigate = useNavigate();

    return (
        <Container className="causeries-list-page" height="fill">
            <Typography intrinsic="h2" defaultSpacing>
                Les thématiques
            </Typography>

            {isLoading ? (
                <CauseriesListPageSkeleton />
            ) : (
                thematics.map((thematic) => (
                    <ListItem
                        key={thematic.id}
                        title={thematic.title}
                        type="default"
                        icon={<Icon icon={<ThematicsIconProvider icon={thematic.icon} />} size={24} color="green" />}
                        onClick={() => navigate(`/sante-securite/causeries/list/${thematic.id}`)}
                    />
                ))
            )}
        </Container>
    );
};
